import type { FC } from "react";
import {
  SelectFlatFundingMethodSlot,
  type FlatFundingPick,
  type SelectFlatFundingMethodSlotProps,
} from "../SelectFlatFundingMethodSlot";

export type { FlatFundingPick };

export type SelectFundingMethodSlotProps = Omit<
  SelectFlatFundingMethodSlotProps,
  "ns"
>;

/** Lola confirmation: same flat funding picker as fund-request Transfer. */
export const SelectFundingMethodSlot: FC<SelectFundingMethodSlotProps> = (
  props
) => <SelectFlatFundingMethodSlot ns="lola" {...props} />;
